<template>
        <tr class="texto">
            <td>
                <h3>{{rubricas.nome}}</h3>
                <p><b>Código:</b> {{rubricas.codigo}}</p>
                <p><b>Definição da Rubrica:</b> {{rubricas.descricao}}</p>
                <p><b>Tipo de Rubrica:</b> {{rubricas.tipo}}</p>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="tituloTabela" scope="col" colspan="4">INCIDÊNCIAS</th>
                            </tr>
                            <tr>
                                <th scope="col" class="subTituloTabela">INSS</th>
                                <th scope="col" class="subTituloTabela">IMPOSTO DE RENDA</th>
                                <th scope="col" class="subTituloTabela">FGTS</th>
                                <th scope="col" class="subTituloTabela">CONTRIBUIÇÃO SINDICAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="conteudoTabela">
                                <td>
                                    <b>Incidência de INSS:</b> {{rubricas.insSincidencia}}<br>
                                    <b>Classificação e-Social:</b>  {{rubricas.insSclassificacao}}<br>
                                    <b>Base Legal:</b>  {{rubricas.insSbaselegal}}
                                </td>
                                <td>
                                    <b>Incidência de IR:</b> {{rubricas.iRincidencia}}<br>
                                    <b>Classificação e-Social:</b> {{rubricas.iRclassificacao}}<br>
                                    <b>Base Legal:</b> {{rubricas.iRbaselegal}}
                                </td>
                                <td>
                                    <b>Incidência de FGTS:</b> {{rubricas.fgtSincidencia}}<br>
                                    <b>Classificação e-Social:</b> {{rubricas.fgtSclassificacao}}<br>
                                    <b>Base Legal:</b> {{rubricas.fgtSbaselegal}}
                                </td>
                                <td>
                                    <b>Incidência de Sindical:</b> {{rubricas.cSincidencia}}<br>
                                    <b>Classificação e-Social:</b> {{rubricas.cSclassificacao}}<br>
                                    <b>Base Legal:</b> {{rubricas.cSbaselegal}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="tituloTabela" scope="col" colspan="5">REPERCUTE EM:</th>
                            </tr>
                            <tr>
                                <th scope="col" class="subTituloTabela">DSR</th>
                                <th scope="col" class="subTituloTabela">FÉRIAS</th>
                                <th scope="col" class="subTituloTabela">Aviso Prévio</th>
                                <th scope="col" class="subTituloTabela">13º Salário</th>
                                <th scope="col" class="subTituloTabela">Afastamento Previdenciário</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="conteudoTabela">
                                <td>{{this.rubricas.dsr==true ? this.dsr="Sim" : this.dsr="Não"}}</td>
                                <td>{{this.rubricas.ferias==true ? this.ferias="Sim" : this.ferias="Não"}}</td>
                                <td>{{this.rubricas.avisO_PREVIO==true ? this.avisoPrevio="Sim" : this.avisoPrevio="Não"}}</td>
                                <td>{{this.rubricas.decimoterceirosalario==true ?  this.decimoTerceiroSalario="Sim" :  this.decimoTerceiroSalario="Não"}}</td>
                                <td>{{this.rubricas.afastamento==true ? this.afastamento="Sim" : this.afastamento="Não"}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </td>
        </tr>
</template>
<script>
export default {
    props: ["rubricas"],
    data(){
        return{

        }
    },
}
</script>
<style scoped>
.texto{
    width: inherit;
}
.texto p{
    font-size: .9em;
}
.tituloTabela{
    text-align: center;
}
.subTituloTabela{
    font-size: .8em;
    vertical-align: middle;
    text-align: center;
}
.conteudoTabela{
    font-size: .7em;
}
.conteudoTabela td{
    width: 12em;
}
</style>





// WEBPACK FOOTER //
// src/components/rubricas-item.vue